import { Col, Radio, Typography } from "antd";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import PriceFormatter from "apps/Common/PriceFormatter";
import TruncatedText from "apps/Common/TruncatedText";
import { FC, useState } from "react";

const PackageItem: FC<{ option: any; isSelected: boolean }> = ({
  option,
  isSelected,
}) => {
  const { Text } = Typography;
  console.log("option", option);
  return (
    <>
      <Col
        key={option.id}
        xs={24}
        className={`!border-1 !h-[150px] !flex items-center p-4 !rounded-md ${
          isSelected
            ? "!bg-blue-100 !border-blue-500"
            : "!bg-whte !border-blue-500"
        }`}
        style={{
          backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='${
            isSelected ? "rgb(22,119,255)" : "RGB(218 219 221)"
          }' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top",
        }}
      >
        <Radio value={option.id} className="flex-1">
          <div
            className={`!flex gap-2 !items-center ${
              isSelected ? "!text-blue-600" : "!text-blue-400"
            }`}
          >
            <LazyLoadImage
              classNames="!hidden xl:!block"
              wrapperHeight="80px"
              wrapperWidth="80px"
              src="https://img.freepik.com/premium-vector/business-making-concept-with-people-scene-flat-cartoon-design-businesswoman-creates-plan-organizing-business-processes-invests-new-company-vector-illustration-visual-story-web_9209-9266.jpg?semt=ais_incoming"
              alt=""
              style={{ objectFit: "cover" }}
            />
            <div>
              <TruncatedText
                maxLines={1}
                title={option?.name}
                textClassName="!font-bold !text-sm  md:!text-lg !text-black"
              />

              <TruncatedText
                maxLines={2}
                title={option?.description}
                textClassName={`!font-bold !text-xs md:!text-sm ${
                  isSelected ? "!text-blue-400" : "!text-black"
                }`}
              />
            </div>
          </div>
        </Radio>
        {!option.inUser && (
          <>
            <div className="flex gap-2 items-center ">
              <div>
                {option?.priceWithDiscount > 0 &&
                option?.priceWithDiscount !== option?.price ? (
                  <>
                    <div>
                    <Text
                  className={`  
                  !text-red-500  !line-through !font-normal
                  `}
                >
                  <PriceFormatter
                  classNames="!text-red-500  !line-through !font-normal"
                  inputPrice={option?.price} />
                 
                </Text>
                    </div>
                    <div>
                      <Text
                        className={`text-xl ${
                          isSelected ? "!text-blue-400" : "!text-black"
                        }`}
                      >
                        <PriceFormatter
                          inputPrice={option?.priceWithDiscount}
                        />
                      </Text>
                    </div>
                  </>
                ) : (
                  <>
                    <Text
                      className={`text-2xl font-bold ${
                        isSelected ? "!text-black" : "!text-blue-400"
                      }`}
                    >
                      <PriceFormatter inputPrice={option?.price} />
                    </Text>
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </Col>
    </>
  );
};

export default PackageItem;
